import React from 'react';

let ListCards = (props) => {
  let card = props.card;
  let priorityClasses = ["none", "low", "medium", "high"];
  let priority;
  if (Object.keys(card).length !== 0 && card.constructor === Object) {
    priority = props.priority;
  } else {
    priority = 0;
  }
  if (Object.keys(card).length === 0 && card.constructor === Object) {
    return(
      <span 
      className={`visual ${priorityClasses[priority]}`}>{props.abr}
      </span>
    )
  } else {
    return(
      <span 
      className={`visual ${priorityClasses[priority]}`} 
      key={card.id}>{props.abr}
      </span>
    )
  }    
}

export default ListCards;


// WEBPACK FOOTER //
// ./src/Containers/ListCards.js